import api, { adminApiPrefix } from './Api';
import {
  Tax,
  taxFromResponse,
  taxToUpsertRequest,
} from '../interfaces/Tax/Tax';

const taxAdminApiPrefix = `${adminApiPrefix}/taxes`;

export const createTax = async (tax: Tax): Promise<Tax> => {
  const response = await api.post(taxAdminApiPrefix, taxToUpsertRequest(tax));

  return taxFromResponse(response.data?.data);
};

export const getTaxes = async (): Promise<Tax[]> => {
  const response = await api.get(taxAdminApiPrefix);

  return (response.data?.data ?? []).map((tax: any) => taxFromResponse(tax));
};

export const getTax = async (id: number): Promise<Tax> => {
  const response = await api.get(`${taxAdminApiPrefix}/${id}`);

  return taxFromResponse(response.data?.data);
};

export const updateTax = async (tax: Tax): Promise<Tax> => {
  const response = await api.put(
    `${taxAdminApiPrefix}/${tax.id}`,
    taxToUpsertRequest(tax),
  );

  return taxFromResponse(response.data?.data);
};

export const deleteTax = async (id: number): Promise<void> =>
  api.delete(`${taxAdminApiPrefix}/${id}`);
